// Stable per-visitor token for this Connect host's tab session (SUR-1918,
// SUR-1883). It keys the analytics PageView AND the contact-attribution
// PixelSession, and is carried into registration so anonymous property views
// backfill onto the new contact once they sign in. Stored in sessionStorage
// (scoped per Connect site + tab: origin, plus the path-preview base when
// agents share the dev host). Returns null in private mode where
// sessionStorage/crypto are unavailable.
import { connectBase } from "./base_path";

export function connectPixelToken() {
  try {
    const key = `ssc_pv${connectBase() ? `:${connectBase()}` : ""}`;
    let token = sessionStorage.getItem(key);
    if (!token) {
      token =
        (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
        `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem(key, token);
    }
    return token;
  } catch (_e) {
    return null;
  }
}
